import { render } from "./BattleScreenPortal.vue?vue&type=template&id=8a398ca8&scoped=true"
import script from "./BattleScreenPortal.vue?vue&type=script&lang=js"
export * from "./BattleScreenPortal.vue?vue&type=script&lang=js"

import "./BattleScreenPortal.vue?vue&type=style&index=0&id=8a398ca8&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a398ca8"]])

export default __exports__